"use strict";

exports.__esModule = true;
exports.AVIDashboard = exports["default"] = exports.withAVIDashboardContext = exports.AVIDashboardContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dc = _interopRequireDefault(require("dc"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AVIDashboardContext = _react["default"].createContext();

exports.AVIDashboardContext = AVIDashboardContext;

var withAVIDashboardContext = function withAVIDashboardContext(Component) {
  return _react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(AVIDashboardContext.Consumer, null, function (value) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, value, {
        ref: ref
      }));
    });
  });
};
/**
 * AVIDashboard wraps `crossfilter` in the following way
 * this should be generally changed
 * state filters has all the filters from the dc.js / crossfilter each time crossfilter is changing state should follow this whatever happedns
 * when this component gets a new props if does update itself, receiving props is chaning the state
 * only on Crossfilter change in running setState for changing the states `crossfilterFilters`
 *
 */

/** Wraps `crossfilter` and follows changes in filters. */


exports.withAVIDashboardContext = withAVIDashboardContext;

var AVIDashboard = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVIDashboard, _Component);

  function AVIDashboard(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "onBrushStart", function () {
      _this.isChanging = true;
    });

    _defineProperty(_assertThisInitialized(_this), "onBrushEnd", function () {
      _this.isChanging = false;
    });

    _this.register = _this.register.bind(_assertThisInitialized(_this));
    _this.unregister = _this.unregister.bind(_assertThisInitialized(_this));
    _this.onBrushStart = _this.onBrushStart.bind(_assertThisInitialized(_this));
    _this.onBrushEnd = _this.onBrushEnd.bind(_assertThisInitialized(_this)); // Render key to trigger re-render of tree when crossfilter is replaced.

    _this.renderKey = 1;
    _this.isChanging = false;
    _this.state = {
      context: {
        register: _this.register,
        unregister: _this.unregister,
        crossfilter: props.crossfilter,
        chartGroup: props.chartGroup,
        onBrushStart: _this.onBrushStart,
        onBrushEnd: _this.onBrushEnd
      },
      crossfilterFilters: {},
      charts: {},
      chartToId: {},
      chartsInitiated: {}
    };
    _this._chartsToRegister = [];
    _this.onCrossfilterChange = _this.onCrossfilterChange.bind(_assertThisInitialized(_this));
    _this.removeCrossfilterOnChange = props.crossfilter.onChange(_this.onCrossfilterChange);
    return _this;
  }

  var _proto = AVIDashboard.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.removeCrossfilterOnChange) this.removeCrossfilterOnChange();
  };

  _proto.componentDidCatch = function componentDidCatch(error, info) {
    // TODO: how should we handle this?
    console.error('componentDidCatch', error, info);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (JSON.stringify(prevState.crossfilterFilters) != JSON.stringify(this.state.crossfilterFilters)) {
      this.onStateFiltersChange();
    }

    if (prevState.charts != this.state.charts) {
      /** we have new charts regirested */
    }

    if (prevProps.filters != this.props.filters && this.props.filters) {
      this.applyFilters(this.props.filters);
    }

    if (prevProps.crossfilter != this.props.crossfilter) {
      if (this.removeCrossfilterOnChange) {
        this.removeCrossfilterOnChange();
      }

      this.removeCrossfilterOnChange = this.props.crossfilter.onChange(this.onCrossfilterChange);
      this.renderKey += 1;
      this.setState(function (state) {
        return {
          context: _extends({}, state.context, {
            crossfilter: _this2.props.crossfilter
          })
        };
      });
      this.onCrossfilterReplaced(prevProps.crossfilter);
    }
  }
  /** called when old crossfilter is replaced with new one - new set of data, eg after API call */
  ;

  _proto.onCrossfilterReplaced = function onCrossfilterReplaced(prevCrossfilter) {
    if (this.props.onCrossfilterReplaced) {
      this.props.onCrossfilterReplaced(this.props.crossfilter, prevCrossfilter);
    }
  }
  /**
   * Returns current filters from registered dc.js charts
   */
  ;

  _proto.getCurrentFilters = function getCurrentFilters() {
    var _this3 = this;

    var currentFilters = {};

    _dc["default"].chartRegistry.list(this.props.chartGroup).forEach(function (chart) {
      currentFilters[_this3.state.chartToId[chart.chartID()] || chart.chartID()] = chart.filters().slice();
    });

    return currentFilters;
  };

  _proto.onCrossfilterChange = function onCrossfilterChange(e) {
    var _this4 = this;

    if (e === 'dataAdded') {
      _dc["default"].redrawAll(this.props.chartGroup);
    }

    if (this.isChanging) {
      /** Do not change state while changing the filters */
      return;
    }

    if (e === 'filtered') {
      this.setState(function (state) {
        var newFilters = _this4.getCurrentFilters();

        if (JSON.stringify(state.crossfilterFilters) === JSON.stringify(newFilters)) {
          return {};
        }

        return {
          crossfilterFilters: newFilters
        };
      });
    }
  };

  _proto.onStateFiltersChange = function onStateFiltersChange() {
    this.props.onFilterChange(this.props.crossfilter, this.state.crossfilterFilters, this.isChanging);
  };

  _proto.getChartIdMapping = function getChartIdMapping() {
    var mapping = {};

    _dc["default"].chartRegistry.list(this.props.chartGroup).forEach(function (chart) {
      mapping[chart.name || chart.chartID()] = chart;
    });

    return mapping;
  };

  _proto.applyFilters = function applyFilters(filters) {
    if (filters === void 0) {
      filters = {};
    }

    /** there is no way to apply many filters at one time,
     * `this.isChanging` is blocking `onCrossfilterChange` for duration of changing filters
     * otherwise  `this.props.crossfilter.onChange` would be called multiple times */
    this.isChanging = true;
    var filtersChanged = false;
    Object.entries(this.state.charts).forEach(function (_ref) {
      var id = _ref[0],
          chart = _ref[1];

      if (JSON.stringify(chart.filters()) !== JSON.stringify(filters[id] || [])) {
        if (filters[id]) {
          chart.replaceFilter([filters[id]]);
        } else {
          chart.filter(null);
        }

        filtersChanged = true;
      }
    });
    if (filtersChanged) _dc["default"].redrawAll(this.props.chartGroup);
    this.isChanging = false;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.filters) {
      this.applyFilters(this.props.filters);
    }
  };

  _proto.checkChartsInitialized = function checkChartsInitialized() {
    if (Object.values(this.state.chartsInitiated).indexOf(false) !== -1) {
      return;
    }

    this.props.onChartsInitialized && this.props.onChartsInitialized();

    if (this.props.filters) {
      this.applyFilters(this.props.filters);
    }
  };

  _proto.register = function register(chart, name, delayInit) {
    var _this5 = this;

    if (delayInit === void 0) {
      delayInit = true;
    }

    chart.chartGroup(this.props.chartGroup);
    /**
     * we have to create an array of `_chartsToRegister` because there is no other way to update
     * react state array in component one lifecycle
     */

    this._chartsToRegister = this._chartsToRegister || [];

    this._chartsToRegister.push({
      name: name || chart.chartID(),
      ref: chart,
      delayInit: delayInit
    });

    if (delayInit) {
      chart.on('postRender', function (chart) {
        var _extends2;

        if (_this5.state.chartsInitiated[_this5.state.chartToId[chart.chartID()]]) return;

        _this5.setState({
          chartsInitiated: _extends({}, _this5.state.chartsInitiated, (_extends2 = {}, _extends2[_this5.state.chartToId[chart.chartID()]] = true, _extends2))
        }, function () {
          return _this5.checkChartsInitialized();
        });
      });
    }

    this.setState(function () {
      if (_this5._chartsToRegister.length === 0) {
        return;
      }

      var charts = Object.assign({}, _this5.state.charts);
      var chartToId = Object.assign({}, _this5.state.chartToId);

      var chartsInitiated = _extends({}, _this5.state.chartsInitiated);

      _this5._chartsToRegister.forEach(function (chart) {
        if (chart.delayInit) {
          chartsInitiated[chart.name] = false;
        }

        chartToId[chart.ref.chartID()] = chart.name;
        charts[chart.name] = chart.ref;
      });

      _this5._chartsToRegister = [];
      return {
        charts: charts,
        chartToId: chartToId,
        chartsInitiated: chartsInitiated
      };
    });
  };

  _proto.unregister = function unregister(chart, name) {
    var _this6 = this;

    _dc["default"].chartRegistry.deregister(chart, this.props.chartGroup);
    /**
     * we have to create an array of `_chartsToUnregister` because there is no other way to update
     * react state array in component one lifecycle
     */


    this._chartsToUnregister = this._chartsToUnregister || [];

    this._chartsToUnregister.push({
      name: name || chart.chartID(),
      ref: chart
    });

    this.setState(function () {
      if (_this6._chartsToUnregister.length === 0) {
        return;
      }

      var charts = Object.assign({}, _this6.state.charts);
      var chartToId = Object.assign({}, _this6.state.chartToId);

      _this6._chartsToUnregister.forEach(function (chart) {
        delete charts[chart.name];
        delete chartToId[chart.ref.chartID()];
      });

      _this6._chartsToUnregister = [];
      return {
        charts: charts,
        chartToId: chartToId
      };
    });
  };

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(AVIDashboardContext.Provider, {
      value: this.state.context
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: this.renderKey,
      className: "avi-dashboard dashboard"
    }, this.props.children));
  };

  return AVIDashboard;
}(_react.Component);

exports.AVIDashboard = exports["default"] = AVIDashboard;

_defineProperty(AVIDashboard, "defaultProps", {
  onFilterChange: function onFilterChange(crossfilter, currentFiltersArray, isChanging) {},
  onCrossfilterReplaced: function onCrossfilterReplaced(crossfilter, prevCrossfilter) {}
});

AVIDashboard.propTypes = process.env.NODE_ENV !== "production" ? {
  /** `crossfilter` object. It is recommended to use remove/add instead of creating a new crossfilter object when data changes. */
  crossfilter: _propTypes["default"].object.isRequired,

  /** Global unique name of a chart group */
  chartGroup: _propTypes["default"].string.isRequired,

  /** callback called when `crossfilter` where changed, `callback(crossfilter, currentFiltersArray, isChanging)` */
  onFilterChange: _propTypes["default"].func,

  /** callback called when old crossfilter is replaced with new one - new set of data, eg after API cal `callback(crossfilter, prevCrossfilter)` */
  onCrossfilterReplaced: _propTypes["default"].func,

  /** Array of filters to be set on `dc` */
  filters: _propTypes["default"].object,

  /** Callback used to tell if charts are rendered */
  onChartsInitialized: _propTypes["default"].func
} : {};